// extracted by mini-css-extract-plugin
export var childrenContainer = "_bi-0";